import { inject } from '@angular/core';
import { Route } from '@angular/router';
import { ngxPermissionsGuard } from 'ngx-permissions';
import { FeatureFlagService, RolePermissions } from 'shared/domain';
import { canDeactivateComponentGuard } from 'shared/util-common';

import { isMobileGuard } from '../../../shared/util-common/src/lib/guards/is-mobile.guard';

export const GUIDELINE_PAGE_ROUTES: Route[] = [
  {
    path: 'edit/:id',
    title: 'Edit Guideline',
    canActivate: [isMobileGuard, ngxPermissionsGuard],
    canDeactivate: [canDeactivateComponentGuard],
    loadComponent: () => import('./guideline-edit/guideline-edit-page.component').then((m) => m.GuidelineEditPageComponent),
    data: {
      availableOffline: true,
      permissions: {
        only: [RolePermissions.editGuideline],
        redirectTo: '/smartbook',
      },
    },
  },
  {
    path: 'preview/:id',
    title: 'Preview Guideline',
    loadComponent: () => import('./guideline-preview/guideline-preview-page.component').then((m) => m.GuidelinePreviewPageComponent),
  },
  {
    path: 'review/:id',
    title: 'Review Guideline',
    canActivate: [ngxPermissionsGuard],
    data: {
      permissions: {
        only: [RolePermissions.viewManagePage, RolePermissions.viewReviewPage],
        redirectTo: '/not-allowed',
      },
    },
    loadComponent: () => import('./guideline-review/guideline-review-page.component').then((m) => m.GuidelineReviewPageComponent),
  },
  {
    path: 'add',
    canMatch: [() => inject(FeatureFlagService).editorEnabled()],
    canActivate: [ngxPermissionsGuard],
    canDeactivate: [canDeactivateComponentGuard],
    loadComponent: () => import('./guideline-edit/guideline-edit-page.component').then((m) => m.GuidelineEditPageComponent),
    data: {
      permissions: {
        only: [RolePermissions.viewManagePage],
        redirectTo: '/not-allowed',
      },
    },
  },
  {
    path: ':id',
    title: 'View Guideline',
    loadComponent: () => import('./guideline-view/guideline-view-page.component').then((m) => m.GuidelineViewPageComponent),
    data: {
      availableOffline: true,
    },
  },
];
